import { render, staticRenderFns } from "./BenefitDetails.vue?vue&type=template&id=5f02a630&scoped=true"
import script from "./BenefitDetails.vue?vue&type=script&lang=js"
export * from "./BenefitDetails.vue?vue&type=script&lang=js"
import style0 from "./BenefitDetails.vue?vue&type=style&index=0&id=5f02a630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02a630",
  null
  
)

export default component.exports